/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBEDS : ANALYTICS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    embedAnalytics: {
        '& .page': {
            width: '100%'
        },
        '& #main': {
            display: 'flex',
            flexWrap: 'wrap'
        }
    }
};